import { render, staticRenderFns } from "./UserPersonList.vue?vue&type=template&id=458dcbb8"
import script from "./UserPersonList.vue?vue&type=script&lang=js"
export * from "./UserPersonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports